export function getSettings() {
}
